module.exports = __webpack_public_path__ + "static/digital-signage.47aa2b7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeSlider/img/digital-signage.jpg
// module id = 176
// module chunks = 19817326959855 219805994829571